import Plyr from 'plyr';

const video = () => {
  const videos = document.querySelectorAll('.u-plyr');

  if (videos.length) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < videos.length; i++) {
      // eslint-disable-next-line no-unused-vars
      const player = new Plyr(videos[i], {
        controls: [
          'play-large',
          'play',
          'progress',
          'current-time',
          'mute',
          'volume',
          'settings',
          'fullscreen',
        ],
        hideControls: true,
      });
    }
  }
};
video();
